import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

import { computed, onMounted, PropType, ref, watch } from "vue";
import { getComponentUiText } from "@/utils/utilities";
import ButtonAddAnother from "@/components/wizard/buttonAddAnother.vue";
import store from "@/store";
import draggable from "vuedraggable";
import {
  getDataChecklistGroupAction,
  getDataChecklistGroupTemplateAction,
} from "@/services/recommend";
import unescape from "lodash/unescape";
import ListStep from "./listStep.vue";
import { showErrorAPI } from "@/services/apiRoutes";
import { Checklist } from "@/services/apiRoutes/routes";

export default /*#__PURE__*/_defineComponent({
  __name: 'stepToSolve',
  props: {
  inModalAdd: {
    type: Boolean,
    required: false,
    default: false,
  },
  inModalEdit: {
    type: Boolean,
    required: false,
  },
  action: {
    type: Object as PropType<{
      checklistGroupId: string;
      checklistGroupTemplateId: string;
      arraySteps: Array<{
        id: number;
        title: string;
        description: string;
        optional: boolean;
      }>;
      detailSteps: Array<{
        id: number;
        title: string;
        subTitle: Array<{ content: string }>;
        srcImage: string;
      }>;
    }>,
    required: false,
    default: () => ({}),
  },
  checkListGroupId: {
    type: String,
    required: false,
    default: "",
  },
  checkListGroupTemplateId: {
    type: String,
    required: false,
    default: "",
  },
  disable: {
    type: Boolean,
    required: false,
    default: false,
  },
  isEditActionTable: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: [
  "update:data",
  "is-check-list-step",
  "check-validation",
],
  setup(__props, { emit }) {

const props = __props;





const title = ref("");
const description = ref("");
const optional = ref(false);
const idItemExpand: any = ref(null);
const arraySteps = ref(props.action.arraySteps || []);
const listSteps: any = ref([]);
const listSrepRemove: any = ref([]);
const detailSteps = ref<typeof props.action.detailSteps>(
  props.action.detailSteps || [],
);
const checklistId = computed(() => {
  return store.state.Recommend.checklistReportId;
});
watch(
  () => props.action,
  () => {
    arraySteps.value = props.action.arraySteps || [];
    detailSteps.value = props.action.detailSteps || [];
  },
);

watch(listSteps, (value) => {
  emit("is-check-list-step", value.length === 0);
});

const changeExpand = (id) => {
  idItemExpand.value = id;
};
const getStepToSolve = async (checklistId, checklistGroupId) => {
  try {
    const res = await getDataChecklistGroupAction(
      checklistId,
      checklistGroupId,
    );
    res.data.data.checklistGroups[0]?.checklistGroupActions.forEach((item) => {
      item.id = item.checklistGroupActionId;
      item.checklistGroupActionHtml = unescape(item.checklistGroupActionHtml);
    });
    listSteps.value =
      res.data.data.checklistGroups[0]?.checklistGroupActions.filter(
        (item) => !item.checklistGroupActionIsArchived,
      );
    listSteps.value.sort(
      (a, b) => a.checklistGroupActionOrder - b.checklistGroupActionOrder,
    );
    store.commit("Recommend/SET_LIST_STEP_ACTIONS_PLAN", listSteps.value);
  } catch (error: any) {
    listSteps.value = [];
    showErrorAPI(error, Checklist.getChecklistGroupAction);
  }
};
const getStepToSolveSuggesAction = async (groupTemplateId) => {
  try {
    const res = await getDataChecklistGroupTemplateAction(groupTemplateId);
    if (res.data.data.groupTemplates[0]?.groupTemplateActions) {
      res.data.data.groupTemplates[0]?.groupTemplateActions.forEach((item) => {
        item.checklistGroupActionHtml = unescape(item.groupTemplateActionHtml);
        item.checklistGroupActionName = item.groupTemplateActionName;
        item.checklistGroupActionOrder = item.groupTemplateActionOrder;
        item.id = item.groupTemplateActionId;
        item.checklistGroupActionImages = item.groupTemplateActionImages.map(
          (image) => {
            return {
              checklistGroupActionImageFile: image.groupTemplateActionImageFile,
            };
          },
        );
      });
      listSteps.value = res.data.data.groupTemplates[0]?.groupTemplateActions;
      listSteps.value.sort(
        (a, b) => a.checklistGroupActionOrder - b.checklistGroupActionOrder,
      );
    }
  } catch (error: any) {
    listSteps.value = [];
    showErrorAPI(error, Checklist.getChecklistGroupTemplateAction);
  }
};
onMounted(() => {
  if (props.inModalAdd) {
    // getStepToSolve();
  } else if (props.checkListGroupId || props.action.checklistGroupId) {
    getStepToSolve(
      checklistId.value,
      props.checkListGroupId || props.action.checklistGroupId,
    );
  } else if (
    props.checkListGroupTemplateId ||
    props.action.checklistGroupTemplateId
  ) {
    getStepToSolveSuggesAction(
      props.checkListGroupTemplateId || props.action.checklistGroupTemplateId,
    );
  }
});
const removeStep = (index) => {
  store.commit("Recommend/SET_LIST_STEP_REMOVED", listSteps.value[index]);
  listSteps.value.splice(index, 1);
  store.commit("Recommend/SET_LIST_STEP_ACTIONS_PLAN", listSteps.value);
};
const changeItem = (event) => {
  const checklistOrderOld =
    listSteps.value[event.moved.oldIndex].checklistGroupActionOrder;
  const checklistOrderNew =
    listSteps.value[event.moved.newIndex].checklistGroupActionOrder;
  listSteps.value[event.moved.oldIndex].checklistGroupActionOrder =
    checklistOrderNew;
  listSteps.value[event.moved.newIndex].checklistGroupActionOrder =
    checklistOrderOld;
  listSteps.value.forEach((item, index) => {
    item.checklistGroupActionOrder = index + 1;
  });
  store.commit("Recommend/SET_LIST_STEP_ACTIONS_PLAN", listSteps.value);
};
const handleUpdateData = (data, index) => {
  listSteps.value[index] = data;
  store.commit("Recommend/SET_LIST_STEP_ACTIONS_PLAN", listSteps.value);
  emit("update:data", data);
};
const addStep = () => {
  let id = 0;
  let checklistGroupActionOrder = 0;
  if (listSteps.value.length === 0) {
    id = 0;
    checklistGroupActionOrder = 0;
  } else {
    id = listSteps.value.reduce((max, item) => {
      return item.id > max ? item.id : max;
    }, listSteps.value[0].id);
    checklistGroupActionOrder = listSteps.value.reduce((max, item) => {
      return item.checklistGroupActionOrder > max
        ? item.checklistGroupActionOrder
        : max;
    }, listSteps.value[0].checklistGroupActionOrder);
  }
  title.value = "";
  description.value = "";
  optional.value = false;
  idItemExpand.value = id + 1;
  listSteps.value.push({
    id: id + 1,
    title: "",
    checklistGroupActionHtml: "",
    optional: false,
    checklistGroupActionOrder: checklistGroupActionOrder + 1,
  });
  store.commit("Recommend/SET_LIST_STEP_ACTIONS_PLAN", listSteps.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (listSteps.value.length)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(`tw-flex tw-flex-col ${
        __props.inModalEdit || __props.inModalAdd ? 'tw-gap-[15px]' : 'tw-gap-[25px]'
      } ${
        __props.inModalEdit || __props.inModalAdd
          ? 'step__to__solve__in__modal'
          : 'step__to__solve__out__modal'
      }`)
        }, [
          _createVNode(_unref(draggable), {
            list: listSteps.value,
            "item-key": "id",
            disabled: __props.disable || __props.action?.checklistGroupTemplateId ? true : false,
            handle: ".drag-handle",
            onChange: changeItem
          }, {
            item: _withCtx(({ element, index }) => [
              _createVNode(ListStep, {
                item: element,
                index: index,
                "id-item-expand": idItemExpand.value,
                "in-modal-edit": __props.inModalEdit,
                "in-modal-add": __props.inModalAdd,
                "checklist-group-id": __props.checkListGroupId,
                action: __props.action.checklistGroupId,
                "is-edit-action": __props.isEditActionTable,
                onChangeExpand: changeExpand,
                onRemoveStep: removeStep,
                onHandleUpdateData: handleUpdateData
              }, null, 8, ["item", "index", "id-item-expand", "in-modal-edit", "in-modal-add", "checklist-group-id", "action", "is-edit-action"])
            ]),
            _: 1
          }, 8, ["list", "disabled"])
        ], 2))
      : _createCommentVNode("", true),
    (
        ((__props.inModalEdit && (__props.checkListGroupId || __props.action.checklistGroupId)) ||
          __props.inModalAdd) &&
        !__props.isEditActionTable
      )
      ? (_openBlock(), _createBlock(ButtonAddAnother, {
          key: 1,
          id: "addStep",
          "style-button": '!tw-border-transparent !tw-shadow-none',
          onClick: addStep
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(listSteps.value.length === 0
          ? _unref(getComponentUiText)(
              "app-assess-recommendations-edit-action-modal-add-step-to-solve-1",
            )
          : _unref(getComponentUiText)(
              "app-assess-recommendations-edit-action-modal-add-task-other-1",
            )), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})